import { render, staticRenderFns } from "./_verifyClientModal.vue?vue&type=template&id=1d60e7da"
import script from "./_verifyClientModal.vue?vue&type=script&lang=js"
export * from "./_verifyClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports